// src/features/expenses/components/GeneralExpenseForm/index.jsx
import React, { useState, useEffect } from 'react';
import { fetchExpenseCategories, createExpense } from '../../../../api';

function GeneralExpenseForm({ onExpenseAdded }) {
  const [expenseData, setExpenseData] = useState({
    category:     '',
    description:  '',
    amount:       '',
    expense_date: new Date().toISOString().slice(0, 10),
  });
  const [categories,        setCategories]        = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [submitting,        setSubmitting]         = useState(false);
  const [error,             setError]              = useState('');

  useEffect(() => {
    fetchExpenseCategories('general')
      .then(res => setCategories(res.data))
      .catch(() => setError('فشل في تحميل حسابات المصاريف العامة.'))
      .finally(() => setLoadingCategories(false));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setExpenseData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!expenseData.category || !expenseData.amount || !expenseData.description) {
      setError('يرجى ملء جميع الحقول.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await createExpense({
        ...expenseData,
        category: parseInt(expenseData.category),
      });
      setExpenseData({
        category: '', description: '', amount: '',
        expense_date: new Date().toISOString().slice(0, 10),
      });
      onExpenseAdded();
    } catch {
      setError('حدث خطأ أثناء حفظ المصروف.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{
      border:       '2px solid var(--color-primary-border)',
      borderRadius: 'var(--radius-md)',
      padding:      'var(--space-5)',
      marginTop:    'var(--space-5)',
      background:   'var(--bg-subtle)',
    }}>
      <form
        onSubmit={handleSubmit}
        style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}
      >
        <h4 style={{ margin: 0, color: 'var(--color-primary)', fontSize: 'var(--font-size-md)' }}>
          إضافة مصروف عام جديد
        </h4>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-3)' }}>
          <select
            name="category"
            value={expenseData.category}
            onChange={handleChange}
            required
            disabled={loadingCategories}
          >
            <option value="">{loadingCategories ? 'جاري التحميل...' : '-- اختر حساب المصروف --'}</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>

          <input
            type="number"
            step="any"
            name="amount"
            value={expenseData.amount}
            onChange={handleChange}
            placeholder="المبلغ"
            required
          />
        </div>

        <input
          type="text"
          name="description"
          value={expenseData.description}
          onChange={handleChange}
          placeholder="وصف المصروف (مثال: فاتورة كهرباء، إيجار)"
          required
        />

        <input
          type="date"
          name="expense_date"
          value={expenseData.expense_date}
          onChange={handleChange}
          required
        />

        {error && (
          <p style={{
            margin:       0,
            padding:      'var(--space-3) var(--space-4)',
            background:   'var(--color-danger-subtle)',
            border:       '1px solid var(--color-danger-muted)',
            borderRight:  '3px solid var(--color-danger)',
            borderRadius: 'var(--radius-md)',
            color:        'var(--color-danger-text)',
            fontSize:     'var(--font-size-sm)',
            fontWeight:   'var(--font-semibold)',
          }}>
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={submitting}
          style={{
            padding:      'var(--space-3) var(--space-5)',
            background:   submitting ? 'var(--text-muted)' : 'var(--color-primary)',
            color:        'var(--text-on-primary)',
            border:       'none',
            borderRadius: 'var(--radius-md)',
            fontFamily:   'var(--font-family)',
            fontSize:     'var(--font-size-sm)',
            fontWeight:   'var(--font-semibold)',
            cursor:       submitting ? 'not-allowed' : 'pointer',
            transition:   'var(--transition-fast)',
          }}
        >
          {submitting ? 'جاري الحفظ...' : '+ حفظ المصروف العام'}
        </button>
      </form>
    </div>
  );
}

export default GeneralExpenseForm;